import React from 'react'
import { Link } from 'react-router-dom'


const NotFound = () => {
    document.title="Lost"
    return (
        <div data-testid="page_404" className="page_404">
            <div className="page_404_container">
               <div className="four_zero_four_bg">
                </div>
                <div className="contant_box_404"> 
                    <h3>It looks like you're lost!</h3>
                    <p>The page you are looking for is not available!</p>
                    <Link to="/" className="link_404">Go to Dashboard</Link>
                </div>
            </div>
        </div>
    )
}

export default NotFound